
import React, { useState } from 'react';
import IntRangeWidget from './int-range-widget';

function FloatRangeWidget(props) {
  // Use IntRangeWidget logic as base
  // Local state for input type
  const [inputType] = useState("Decimal");

  // Input validation for float values
  function onInputChange(ev, type, setStartValue, setEndValue, setError, setErrorMessage) {
    ev.preventDefault && ev.preventDefault();
    setError(false);
    setErrorMessage("");
    const value = ev.target.value;
    // Float validation: up to 4 decimals
    const validated = value.match(/^-?\d*(\.\d{0,4})?$/g);
    if (validated || value === "") {
      if (type === 'start') setStartValue(value);
      if (type === 'end') setEndValue(value);
    }
  }

  // Pass custom onInputChange and inputType to IntRangeWidgetF
  return (
    <IntRangeWidget
      {...props}
      inputType={inputType}
      onInputChange={onInputChange}
      floatMode={true}
    />
  );
}

export default FloatRangeWidget;
